<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>RBAC Role</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Role &amp; Permissions">
      <ng-template matTabContent>
        <app-rbac-roles-edit
          #editComponent
          [rbac_role_id]="rbac_role_id"
          (rbac_role_id_changed)="rbac_role_id = $event"
          (close_dialog)="onClose()">
        </app-rbac-roles-edit>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="utils.getLangTerm('employees.plural', 'Employees')" *ngIf="rbac_role_id && canViewMembers">
      <ng-template matTabContent>
        <app-rbac-roles-users [rbac_role_id]="rbac_role_id"></app-rbac-roles-users>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="selectedTabIndex === 0 && !editComponent?.isReadOnly">
  <button mat-raised-button color="primary" (click)="editComponent?.onSave(false)" [disabled]="!editComponent?.isFormValid">
    <mat-icon>save</mat-icon>
    {{ rbac_role_id ? 'Update Role' : 'Create Role' }}
  </button>
  <button mat-raised-button color="primary" (click)="editComponent?.onSave(true)" [disabled]="!editComponent?.isFormValid">
    <mat-icon>save</mat-icon>
    {{ rbac_role_id ? 'Update' : 'Save' }} &amp; Close
  </button>
</mat-dialog-actions>
